var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.001,
    height: 15,
    viewBox: "0 0 15.001 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.875,13.75A6.875,6.875,0,1,1,13.75,6.875,6.883,6.883,0,0,1,6.875,13.75Zm0-12.5A5.625,5.625,0,1,0,12.5,6.875,5.631,5.631,0,0,0,6.875,1.25Z",
    fill: "#919191"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.827,21.452a.623.623,0,0,1-.442-.183l-3-3a.625.625,0,0,1,.884-.884l3,3a.624.624,0,0,1-.442,1.067Z",
    transform: "translate(-6.452 -6.452)",
    fill: "#919191"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.0de797b62c68eadcba69360cdcee8bf3.svg";
export { ForwardRef as ReactComponent };